<template>
  <div id="contenedor-excel-contratos">
    <!-- <v-tooltip top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          icon
          v-bind="attrs"
          v-on="on"
          @click="mostrarVentanaExcelContratos = !mostrarVentanaExcelContratos">
          <v-icon> mdi-file-excel </v-icon>
        </v-btn>
      </template>
      <span> Exportar Contratos </span>
    </v-tooltip> -->
    <!-- <v-skeleton-loader
      v-if="$apollo.loading"
      loading
      type="article, actions">
    </v-skeleton-loader> -->
    <!-- <v-card v-if="$apollo.loading">
      <v-container>
        <v-row
          class="fill-height"
          align-content="center"
          justify="center"
        >
          <v-col
            class="text-subtitle-1 text-center"
            cols="12"
          >
            Preparando exportación de contratos...
          </v-col>
          <v-col cols="6">
            <v-progress-linear
              color="primary"
              indeterminate
              rounded
              height="6"
            ></v-progress-linear>
          </v-col>
        </v-row>
      </v-container>
    </v-card> -->
    <v-form
      ref="exportarContratosExcel"
      v-model="formularioValido">
      <v-card>
        <v-card-title class="secondary--text">
          Exportar Contratos
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <template v-if="exportandoContratos">
            <v-container>
              <v-row
                class="fill-height"
                align-content="center"
                justify="center"
              >
                <v-col
                  class="text-subtitle-1 text-center"
                  cols="12"
                >
                  Preparando exportación de contratos...
                </v-col>
                <v-col cols="6">
                  <v-progress-linear
                    color="primary"
                    indeterminate
                    rounded
                    height="6"
                  ></v-progress-linear>
                </v-col>
              </v-row>
            </v-container>
          </template>
          <template v-else>
            <ejercicio-picker
              v-model="filtrosExcel.ejercicio"
              class="my-2">
            </ejercicio-picker>
          </template>
          <!-- <v-radio-group
            v-model="seleccion"
            mandatory>
            <v-radio
              value="listadoActual">
              <template v-slot:label>
                <div>
                  <strong class="secondary--text">Listado Actual</strong>
                </div>
              </template>
            </v-radio>
            <v-radio
              value="rangoFechas">
              <template v-slot:label>
                <div>
                  <strong class="secondary--text">Rango de Fechas</strong>
                </div>
              </template>
            </v-radio>
          </v-radio-group>
          <v-row v-if="seleccion === 'rangoFechas'">
            <custom-date-picker
              v-model="rangoFechas.inicial"
              :rules="[mixReglas.requerido]"
              label="Fecha Inicial">
            </custom-date-picker>
            <custom-date-picker
              v-model="rangoFechas.final"
              :rules="[mixReglas.requerido]"
              label="Fecha Final">
            </custom-date-picker>
          </v-row> -->
          <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            label="Exportar"
            tipo="formAceptar"
            :disabled="exportandoContratos"
            :loading="exportandoContratos"
            @click="generarExcelContratos">
          </custom-button>
        </v-card-actions>
        </v-card-text>
      </v-card>
    </v-form>
  </div>
</template>

<script>
// import CONTRATOS_EXCEL from '@/graphql/querys/administracion/contratos/contratosExcel.gql';
import CONTRATOS_PARA_EXCEL from '@/graphql/querys/administracion/contratos/contratosParaExcel.gql';
import mixGenerarExceles from '@/helpers/mixGenerarExcel';
// import CustomDatePicker from '@/components/inputs/DatePicker.vue';
import CustomButton from '@/components/buttons/Button.vue';
import EjercicioPicker from '@/components/inputs/EjercicioPicker.vue';

// Fila en la que inician los datos con titulos del excel
const filaTitulos = 4;
// const filaSubtitulos = filaTitulos + 1;
const filaInicioDatos = filaTitulos + 1;

export default {
  name: 'ExcelContratos',
  mixins: [mixGenerarExceles],
  props: {
    filtros: {
      type: Object,
      required: true,
    },
  },
  components: {
    // CustomDatePicker,
    CustomButton,
    EjercicioPicker,
  },
  data() {
    return {
      skipQuery: true,
      filtrosExcel: {
        ejercicio: new Date().getFullYear(),
      },
      contratosParaExcel: null,
      exportandoContratos: false,
      formularioValido: false,
      estaCargando: false,
      seleccion: 'listadoActual',
      rangoFechas: {
        inicial: null,
        final: null,
      },
      nombreDocumento: 'CONTRATOS EXCEL',
      configuracionExcel: {},
      // Estilo del header
      estiloHeader: {
        font: {
          bold: true,
        },
        alignment: {
          horizontal: 'center',
          vertical: 'center',
          wrapText: true,
        },
      },
      // Datos de los encabezados que apareceran en el excel.
      headersColumnas: [
        {
          value: 'Ejercicio', nombreColumna: 'ejercicio', orden: 0,
        },
        {
          value: 'Numero de Contrato', nombreColumna: 'numero', orden: 1,
        },
        {
          value: 'Fecha de Contrato', nombreColumna: 'fecha', orden: 2,
        },
        {
          value: 'Objeto de Contrato', nombreColumna: 'meta', orden: 3,
        },
        {
          value: 'Programa', nombreColumna: 'programa', orden: 4,
        },
        {
          value: 'Tipo', nombreColumna: 'tipo', orden: 5,
        },
        {
          value: 'Subtipo', nombreColumna: 'subtipo', orden: 6,
        },
        {
          value: 'Modalidad de Contratación', nombreColumna: 'comoSeContrato', orden: 7,
        },
        {
          value: 'Contratista', nombreColumna: 'contratista', orden: 8,
        },
        {
          value: 'Financiamiento', nombreColumna: 'esObraFinanciada', orden: 9,
        },
        {
          value: 'Fecha Inicio Contrato', nombreColumna: 'fechaInicio', orden: 10,
        },
        {
          value: 'Fecha Termino Contrato', nombreColumna: 'fechaTermino', orden: 11,
        },
        {
          value: 'Fecha Inicio Convenida', nombreColumna: 'modificadoFechaInicio', orden: 12,
        },
        {
          value: 'Fecha Termino Convenida', nombreColumna: 'modificadoFechaTermino', orden: 13,
        },
        {
          value: 'Importe Costo Directo', nombreColumna: 'importeCostoDirecto', orden: 14,
        },
        {
          value: 'Importe Costo Indirectos', nombreColumna: 'importeCostoIndirectos', orden: 15,
        },
        {
          value: 'Importe Utilidad', nombreColumna: 'importeUtilidad', orden: 16,
        },
        {
          value: 'Importe Adicionales', nombreColumna: 'importeCargosAdicionales', orden: 17,
        },
        {
          value: 'Importe Contrato Antes Financiamiento', nombreColumna: 'importeAntesFinanciamiento', orden: 18,
        },
        {
          value: 'Importe Financiamiento', nombreColumna: 'importeCostoFinanciero', orden: 19,
        },
        {
          value: 'Importe Contrato antes Iva', nombreColumna: 'importeAntesIva', orden: 20,
        },
        {
          value: 'Importe IVA', nombreColumna: 'importeIva', orden: 21,
        },
        {
          value: 'Importe Total', nombreColumna: 'importeTotal', orden: 22,
        },
        {
          value: 'Importe Total Contrato Despues De Convenios', nombreColumna: 'importeTotalDespuesDeConvenios', orden: 23,
        },
        {
          value: 'Importe Anticipo Inicio Trabajos', nombreColumna: 'importeAnticipoInicioTrabajos', orden: 24,
        },
        {
          value: 'Importe Anticipo Financiamiento', nombreColumna: 'importeAnticipoFinanciamiento', orden: 25,
        },
        {
          value: 'Importe Anticipo', nombreColumna: 'importeAnticipo', orden: 26,
        },
        {
          value: 'Importe Iva Anticipo', nombreColumna: 'importeIvaAnticipo', orden: 27,
        },
        {
          value: 'Importe Total Anticipo', nombreColumna: 'importeTotalAnticipo', orden: 28,
        },
        {
          value: 'Numero Estimaciones', nombreColumna: 'numeroEstimaciones', orden: 29,
        },
        {
          value: 'Importe Estimado Costo Directo', nombreColumna: 'importeEstimadoCostoDirecto', orden: 30,
        },
        {
          value: 'Importe Estimado Indirectos', nombreColumna: 'importeEstimadoIndirectos', orden: 31,
        },
        {
          value: 'Importe Estimado Utilidad', nombreColumna: 'importeEstimadoUtilidad', orden: 32,
        },
        {
          value: 'Importe Estimado Adicionales', nombreColumna: 'importeEstimadoAdicionales', orden: 33,
        },
        {
          value: 'Importe Estimado', nombreColumna: 'importeEstimado', orden: 34,
        },
        {
          value: 'Importe Estimado Normal', nombreColumna: 'importeEstimadoNormal', orden: 35,
        },
        {
          value: 'Importe Estimado Excedente', nombreColumna: 'importeEstimadoExcedente', orden: 36,
        },
        {
          value: 'Importe Estimado Fuera Presupuesto', nombreColumna: 'importeEstimadoFueraPresupuesto', orden: 37,
        },
        {
          value: 'Importe Por Estimar', nombreColumna: 'importePorEstimar', orden: 38,
        },
        {
          value: 'Importe Amortizado Inicio Trabajos', nombreColumna: 'importeAmortizadoInicioTrabajos', orden: 39,
        },
        {
          value: 'Importe Amortizado Financiamiento', nombreColumna: 'importeAmortizadoFinanciamiento', orden: 40,
        },
        {
          value: 'Importe Amortizado', nombreColumna: 'importeAmortizado', orden: 41,
        },
        {
          value: 'Importe Por Amortizar', nombreColumna: 'importePorAmortizar', orden: 42,
        },
        {
          value: 'Importe Estimado Financiamiento', nombreColumna: 'importeEstimadoFinanciamiento', orden: 43,
        },
        {
          value: 'Importe Estimaciones Antes Iva', nombreColumna: 'importeEstimacionesAntesIva', orden: 44,
        },
        {
          value: 'Importe Estimaciones Iva', nombreColumna: 'importeEstimacionesIva', orden: 45,
        },
        {
          value: 'Importe Estimaciones Facturado', nombreColumna: 'importeEstimacionesFacturado', orden: 46,
        },
        {
          value: 'Importe Estimaciones Deducciones', nombreColumna: 'importeEstimacionesDeducciones', orden: 47,
        },
        {
          value: 'Importe Estimaciones Retenido', nombreColumna: 'importeEstimacionesRetenido', orden: 48,
        },
        {
          value: 'Importe Estimaciones Devuelto', nombreColumna: 'importeEstimacionesDevuelto', orden: 49,
        },
        {
          value: 'Importe Estimaciones Sancion', nombreColumna: 'importeEstimacionesSancion', orden: 50,
        },
        {
          value: 'Importe Estimaciones Ajuste', nombreColumna: 'importeEstimacionesAjuste', orden: 51,
        },
        {
          value: 'Importe Estimaciones Liquido', nombreColumna: 'importeEstimacionesLiquido', orden: 52,
        },
        {
          value: 'Importe Escalatorias Antes Iva', nombreColumna: 'importeEscalatoriasAntesIva', orden: 53,
        },
        {
          value: 'Importe Escalatorias Iva', nombreColumna: 'importeEscalatoriasIva', orden: 54,
        },
        {
          value: 'Importe Escalatorias Facturado', nombreColumna: 'importeEscalatoriasFacturado', orden: 55,
        },
        {
          value: 'Importe Gastos Antes Iva', nombreColumna: 'importeGastosAntesIva', orden: 56,
        },
        {
          value: 'Importe Gastos Iva', nombreColumna: 'importeGastosIva', orden: 57,
        },
        {
          value: 'Importe Gastos Facturado', nombreColumna: 'importeGastosFacturado', orden: 58,
        },
        {
          value: 'Importe Ejercido Contrato Antes Iva', nombreColumna: 'importeEjercidoContratoAntesIva', orden: 59,
        },
        {
          value: 'Importe Ejercido Contrato Iva', nombreColumna: 'importeEjercidoContratoIva', orden: 60,
        },
        {
          value: 'Importe Ejercido Contrato Facturado', nombreColumna: 'importeEjercidoContratoFacturado', orden: 61,
        },
        {
          value: 'Importe Facturado Solicitado', nombreColumna: 'importeFacturdoSolicitado', orden: 62,
        },
        {
          value: 'Importe Facturado Pagado', nombreColumna: 'importeFacturadoPagado', orden: 63,
        },
        {
          value: 'Importe Facturado Por Pagar', nombreColumna: 'importeFacturadoPorPagar', orden: 64,
        },
        {
          value: 'Porcentaje Avance Programado', nombreColumna: 'porcentajeAvanceProgramado', orden: 65,
        },
        {
          value: 'PorcentajeAvanceFisico', nombreColumna: 'porcentajeAvanceFisico', orden: 66,
        },
        {
          value: 'Porcentaje Avance Financiero', nombreColumna: 'porcentajeAvanceFinanciero', orden: 67,
        },
        {
          value: 'Atraso', nombreColumna: 'atraso', orden: 68,
        },
        {
          value: 'Residente', nombreColumna: 'residente', orden: 69,
        },
        {
          value: 'Fecha Ultimo Reporte', nombreColumna: 'fechaUltimoReporte', orden: 70,
        },
        {
          value: 'Ultimo Comentario', nombreColumna: 'ultimoComentario', orden: 71,
        },
        {
          value: 'Supervision Externa', nombreColumna: 'supervisionExterna', orden: 72,
        },
        {
          value: 'Fecha Ultima Estimacion', nombreColumna: 'fechaUltimaEstimacion', orden: 73,
        },
        {
          value: 'Con Estimacion Finiquito', nombreColumna: 'conEstimacionFiniquito', orden: 74,
        },
        {
          value: 'Importe Catalogo', nombreColumna: 'importeCatalogo', orden: 75,
        },
        {
          value: 'Fecha Inicio Programa', nombreColumna: 'fechaInicioPrograma', orden: 76,
        },
        {
          value: 'Fecha Fin Programa', nombreColumna: 'fechaFinPrograma', orden: 77,
        },
        // {
        //   value: 'Supervision Externa', nombreColumna: 'columnaRepetida?', orden: 78,
        // },
        {
          value: 'Estatus Contrato', nombreColumna: 'estatusContrato', orden: 79,
        },
        {
          value: 'Expediente Abierto', nombreColumna: 'expedienteAbierto', orden: 80,
        },
        {
          value: 'Documentos Aplican', nombreColumna: 'documentosAplican', orden: 81,
        },
        {
          value: 'Documentos Ok', nombreColumna: 'documentosOk', orden: 82,
        },
        {
          value: 'Documentos Faltantes', nombreColumna: 'documentosFaltantes', orden: 83,
        },
      ],
      noData: [{
        ejercicio: '',
        numero: '',
        fecha: '',
        meta: '',
        programa: '',
        tipo: '',
        subtipo: '',
        comoSeContrato: '',
        contratista: '',
        esObraFinanciada: '',
        fechaInicio: '',
        fechaTermino: '',
        modificadoFechaInicio: '',
        modificadoFechaTermino: '',
        importeCostoDirecto: '',
        importeCostoIndirectos: '',
        importeUtilidad: '',
        importeCargosAdicionales: '',
        importeAntesFinanciamiento: '',
        importeCostoFinanciero: '',
        importeAntesIva: '',
        importeIva: '',
        importeTotal: '',
        importeTotalDespuesDeConvenios: '',
        importeAnticipoInicioTrabajos: '',
        importeAnticipoFinanciamiento: '',
        importeAnticipo: '',
        importeIvaAnticipo: '',
        importeTotalAnticipo: '',
        numeroEstimaciones: '',
        importeEstimadoCostoDirecto: '',
        importeEstimadoIndirectos: '',
        importeEstimadoUtilidad: '',
        importeEstimadoAdicionales: '',
        importeEstimado: '',
        importeEstimadoNormal: '',
        importeEstimadoExcedente: '',
        importeEstimadoFueraPresupuesto: '',
        importePorEstimar: '',
        importeAmortizadoInicioTrabajos: '',
        importeAmortizadoFinanciamiento: '',
        importeAmortizado: '',
        importePorAmortizar: '',
        importeEstimadoFinanciamiento: '',
        importeEstimacionesAntesIva: '',
        importeEstimacionesIva: '',
        importeEstimacionesFacturado: '',
        importeEstimacionesDeducciones: '',
        importeEstimacionesRetenido: '',
        importeEstimacionesDevuelto: '',
        importeEstimacionesSancion: '',
        importeEstimacionesAjuste: '',
        importeEstimacionesLiquido: '',
        importeEscalatoriasAntesIva: '',
        importeEscalatoriasIva: '',
        importeEscalatoriasFacturado: '',
        importeGastosAntesIva: '',
        importeGastosIva: '',
        importeGastosFacturado: '',
        importeEjercidoContratoAntesIva: '',
        importeEjercidoContratoIva: '',
        importeEjercidoContratoFacturado: '',
        importeFacturdoSolicitado: '',
        importeFacturadoPagado: '',
        importeFacturadoPorPagar: '',
        porcentajeAvanceProgramado: '',
        porcentajeAvanceFisico: '',
        porcentajeAvanceFinanciero: '',
        atraso: '',
        residente: '',
        fechaUltimoReporte: '',
        ultimoComentario: '',
        supervisionExterna: '',
        fechaUltimaEstimacion: '',
        conEstimacionFiniquito: '',
        importeCatalogo: '',
        fechaInicioPrograma: '',
        fechaFinPrograma: '',
        estatusContrato: '',
        expedienteAbierto: '',
        documentosAplican: '',
        documentosOk: '',
        documentosFaltantes: '',
      }],
    };
  },
  apollo: {
    // contratos: {
    //   query: CONTRATOS_EXCEL,
    // },
    // contratosParaExcel: {
    //   query: CONTRATOS_PARA_EXCEL,
    //   variables() {
    //     return {
    //       filtros: this.filtrosExcel,
    //     };
    //   },
    //   // update: () => {
    //   //   this.generarExcelContratos();
    //   // },
    //   then: ((response) => {
    //     console.log('Datos del usuario:', response.data.contratosParaExcel);
    //   // Hacer algo con los datos aquí
    //   }),
    //   skip() {
    //     return this.skipQuery;
    //   },
    // },
  },
  watch: {
    filtrosExcel: {
      handler() {
      },
      deep: true,
    },
  },
  methods: {
    async generarExcelContratos() {
      this.exportandoContratos = true;
      const filtrosPeriodo = {
        ejercicio: new Date().getFullYear(),
        periodo: 1,
      };
      if (typeof this.filtrosExcel.ejercicio === 'string') {
        const split = this.filtrosExcel.ejercicio.split('-');
        filtrosPeriodo.ejercicio = Number(split[0]);
        filtrosPeriodo.periodo = Number(split[1]);
      } else {
        filtrosPeriodo.ejercicio = Number(this.filtrosExcel.ejercicio);
      }
      await this.$apollo.query({
        query: CONTRATOS_PARA_EXCEL,
        variables: {
          filtros: filtrosPeriodo,
        },
      }).then(async (response) => {
        this.contratosParaExcel = [...response.data.contratosParaExcel];
        const data = this.crearExcelContratos;
        await this.mixGenerarExcel(data);
      }).catch((error) => {
        this.mixMensajeError(error);
      });
      this.exportandoContratos = false;
    },
    cerrar() {
      this.$refs.exportarContratosExcel.reset();
      this.rangoFechas.inicial = null;
      this.rangoFechas.final = null;
      this.$emit('cerrar');
    },
    getSupervisionExterna(contrato) {
      const supervisionExterna = contrato.contratosRelacionados
        .find((contratoRelacionado) => contratoRelacionado.esSupervisionExterna);
      return supervisionExterna ? supervisionExterna.contratoRelacionado.contratista.nombreRazonSocial : '';
    },
    getDatosExpedienteContrato(expediente) {
      const datos = {
        abierto: 'No',
        documentosAplican: '-',
        documentosOk: '-',
        documentosFaltantes: '-',
      };
      if (expediente.length > 0) {
        const docsAplican = expediente
          .filter((documento) => documento.aplica);
        const docsOk = expediente
          .filter((documentos) => documentos.existe);
        const docsFaltantes = expediente
          .filter((documentos) => !documentos.existe && documentos.aplica);
        datos.abierto = 'Si';
        datos.documentosAplican = docsAplican.length;
        datos.documentosOk = docsOk.length;
        datos.documentosFaltantes = docsFaltantes.length;
      }
      return datos;
    },
    getDatosUltimoReporte(reportesFisicos) {
      const datos = {
        avanceProgramado: '',
        avanceFisico: '',
        avanceFinanciero: '',
        atraso: '',
        fechaUltimoReporte: '',
        ultimoComentario: '',
      };
      if (reportesFisicos.length > 0) {
        const ultimoReporte = reportesFisicos.find((reporte) => reporte.esUltimo);
        datos.avanceProgramado = ultimoReporte.avanceProgramado;
        datos.avanceFisico = ultimoReporte.avanceFisico;
        datos.avanceFinanciero = ultimoReporte.avanceFinanciero;
        datos.atraso = ultimoReporte.avanceProgramado - ultimoReporte.avanceFisico; // verificar
        datos.fechaUltimoReporte = ultimoReporte.fecha;
        datos.ultimoComentario = ultimoReporte.comentarios;
      }
      return datos;
    },
    getDatosEstimaciones(estimaciones) {
      const datos = {
        fechaUltimaEstimacion: '-',
        conEstimacionFiniquito: estimaciones.find((estimacion) => estimacion.esEstimacionFiniquito) ? 'Si' : 'No',
      };
      if (estimaciones.length > 0) {
        const ultimaEstimacion = estimaciones.find(
          (estimacion) => Number(estimacion.numero) === estimaciones.length,
        );
        // datos.fechaUltimaEstimacion = this.$moment(ultimaEstimacion.fechaPresentacion)
        // .format('DD-MM-YYYY');
        datos.fechaUltimaEstimacion = this.$moment(ultimaEstimacion.fechaAl).format('DD-MM-YYYY');
      }
      return datos;
    },
    getFechasPrograma(programas) {
      const datos = {
        fechaInicioPrograma: '',
        fechaTerminoPrograma: '',
      };
      if (programas.length > 0) {
        const programasObras = programas.map((programa) => ([
          ...programa.programa,
        ]));

        const fechasInicio = [];
        const fechasTermino = [];
        // PENDIENTE DEFINIR EL PROGRAMA DE QUE OBRA SE MOSTRARA
        // POR MIENTRAS SE TOMA EL DEL INCIO DEL ARRAY
        const programaPrimerObra = programasObras[0];

        programaPrimerObra.forEach((programa) => {
          fechasInicio.push(programa.fechaInicio);
          fechasTermino.push(programa.fechaTermino);
        });
        const arrFechasInicio = fechasInicio
          .map((fecha) => new Date(`${fecha} 00:00:0`));
        const arrFechasTermino = fechasTermino
          .map((fecha) => new Date(`${fecha} 00:00:0`));

        const fechaInicio = this.$moment(new Date(Math.min.apply(null, arrFechasInicio))).format('DD-MM-YYYY');
        const fechaTermino = this.$moment(new Date(Math.max.apply(null, arrFechasTermino))).format('DD-MM-YYYY');

        datos.fechaInicioPrograma = fechaInicio;
        datos.fechaTerminoPrograma = fechaTermino;
      }
      return datos;
    },
    getDatosExcedentesEstimaciones(estimaciones) {
      const conceptosConExedentes = [];
      if (estimaciones.length > 0) {
        estimaciones.forEach((estimacion) => {
          const conceptoConExedente = this.getConceptosConLosExcedentes(estimacion);
          conceptosConExedentes.push(conceptoConExedente);
        });
      }
      return conceptosConExedentes;
    },
    getConceptosConLosExcedentes(contratoEstimacion) {
      const conceptosConLosExcedentes = contratoEstimacion
        .conceptos
        .map((concepto) => {
          let existeExcedente = false;
          const { cantidad } = concepto;
          const cantidadContratada = concepto.concepto.cantidad;
          const cantidadEstimada = this.$numberRoundDigits(concepto.concepto.estimado
            .filter((estimado) => estimado.estimacion.numero < contratoEstimacion.numero)
            .reduce((v, estimacion) => v + (estimacion.cantidad), 0), 5);
          const cantidadEstimadaActual = cantidadEstimada + cantidad;
          let cantidadExcedente = 0;
          let importeExcedente = 0;

          if (cantidadContratada > 0 && cantidadEstimadaActual > cantidadContratada) {
            existeExcedente = true;
            const diferencia = cantidadEstimadaActual - cantidadContratada;
            cantidadExcedente = diferencia;

            if (diferencia > cantidad) {
              cantidadExcedente = cantidad;
            }

            importeExcedente = this.$numberRound((
              cantidadExcedente * concepto.concepto.precioUnitario));
          }

          return {
            ...concepto,
            cantidadExcedente,
            importeExcedente,
            existeExcedente,
          };
        });
      if (!conceptosConLosExcedentes) return [];
      // Listado de conceptos normales
      const conceptosNormales = conceptosConLosExcedentes
        .filter(({ concepto }) => concepto.cantidad > 0);
      // Listado de conceptos con excedente
      const conceptosConExcedentes = conceptosConLosExcedentes
        .filter((concepto) => concepto.existeExcedente === true);
      // Listado de conceptos FPs
      const conceptosFps = conceptosConLosExcedentes
        .filter(({ concepto }) => concepto.cantidad === 0);
      const datos = {
        importeEstimadoNormal: (this.$ObjSumar(conceptosNormales, 'importe')
          - this.$ObjSumar(conceptosConExcedentes, 'importeExcedente')),
        importeEstimadoExcedente: this.$ObjSumar(conceptosConExcedentes, 'importeExcedente'),
        ImporteEstimadoFueraPresupuesto: this.$ObjSumar(conceptosFps, 'importe'),

      };
      return datos;
    },
    getAmortizacionesContrato(estimaciones) {
      const datos = {
        importeAmortizado: '',
        importeAmortizadoFinanciamiento: '',
        importeAmortizadoInicioTrabajos: '',
      };
      if (estimaciones.length > 0) {
        const importeAmortizadoInicioTrabajos = this.$ObjSumar(estimaciones, 'importeAmortizacionAnticipo');
        const importeAmortizadoFinanciamiento = this.$ObjSumar(estimaciones, 'importeCostoFinancieroAmortizacionAnticipo');

        datos.importeAmortizado = importeAmortizadoInicioTrabajos + importeAmortizadoFinanciamiento;
        datos.importeAmortizadoFinanciamiento = importeAmortizadoFinanciamiento;
        // datos.importeAmortizadoInicioTrabajos = importeAmortizado
        // - importeAmortizadoFinanciamiento;
        datos.importeAmortizadoInicioTrabajos = importeAmortizadoInicioTrabajos;
      }
      return datos;
    },
    getSolicitadoPagado(solicitudesPagos) {
      const importesPagadosYSolicitados = solicitudesPagos.map((solicitudPago) => ({
        importeFacturadoSolicitado: this.$ObjSumar(solicitudPago.detalles, 'importe'),
        importeFacturadoPagado: this.$ObjSumar(solicitudPago.detalles.map((solicitudDetalle) => ({
          importePagado: this.$ObjSumar(solicitudDetalle.pagosDetalles, 'importe'),
        })), 'importePagado'),
      }));
      const importeFacturadoSolicitado = this.$ObjSumar(importesPagadosYSolicitados, 'importeFacturadoSolicitado');
      const importeFacturadoPagado = this.$ObjSumar(importesPagadosYSolicitados, 'importeFacturadoPagado');
      // const importeFacturadoPorPagar = importeFacturadoSolicitado - importeFacturadoPagado;

      return {
        importeFacturadoSolicitado,
        importeFacturadoPagado,
        // importeFacturadoPorPagar,
      };
    },
    getResidenteContrato(contrato) {
      const residente = contrato.responsables.find((responsable) => responsable.principal);
      return residente ? residente.funcionario.nombre : '';
    },
    getImportesEjercidosContrato(contrato) {
      const importeEjercidoContratoAntesIva = this.$ObjSumar(contrato.estimaciones, 'subtotalDos')
      + this.$ObjSumar(contrato.escalatorias, 'importe')
      + this.$ObjSumar(contrato.gastos, 'importe')
      + this.$ObjSumar(contrato.anticipos, 'importe');

      const importeEjercidoContratoIva = this.$ObjSumar(contrato.estimaciones, 'importeIva')
      + this.$ObjSumar(contrato.escalatorias, 'iva')
      + this.$ObjSumar(contrato.gastos, 'iva')
      + this.$ObjSumar(contrato.anticipos, 'iva');

      const importeEjercidoContratoFacturado = importeEjercidoContratoAntesIva
      + importeEjercidoContratoIva;

      return {
        importeEjercidoContratoAntesIva,
        importeEjercidoContratoIva,
        importeEjercidoContratoFacturado,
      };
    },
  },
  computed: {
    getContratosExcel() {
      if (!this.contratosParaExcel) return [];
      return this.contratosParaExcel
      // Separar el tipo de obra
        .map((contrato) => {
          const [obra] = contrato.obras;

          return {
            ...contrato,
            obra: obra || null,
          };
        });
    },
    getContratosExcelFiltrado() {
      if (!this.contratosParaExcel) return [];
      return this.contratosParaExcel
        // Separar el tipo de obra
        .map((contrato) => {
          const [obra] = contrato.obras;

          return {
            ...contrato,
            obra: obra || null,
          };
        })
        .slice()
        .sort((a, b) => new Date(b.fecha) - new Date(a.fecha))
        // Filtrar por ejercicio
        .filter(({ ejercicio }) => ejercicio === this.filtros.ejercicio)
        // Por tipo de obra
        .filter(({ obra }) => {
          if (this.filtros.tipos.length <= 0) return true;
          if (obra === null && this.filtros.tipos.length > 0) return false;
          const idTipo = obra.obra.tipo.id;

          return this.filtros.tipos.includes(idTipo);
        })
        // Filtrar por tipo de contrato
        .filter(({ esObraFinanciada }) => {
          if (this.filtros.financiamiento === 'Todos') return true;

          if (this.filtros.financiamiento === 'Normal') return esObraFinanciada === false;

          return esObraFinanciada === true;
        })
        // Programa de obra
        .filter(({ obra }) => {
          if (this.filtros.programas.length <= 0) return true;
          if (obra === null && this.filtros.programas.length > 0) return false;
          const idPrograma = obra.obra.programa.id;

          return this.filtros.programas.includes(idPrograma);
        })
        // Filtro por contratista
        .filter(({ idContratista }) => {
          const { contratistas } = this.filtros;
          if (contratistas.length <= 0) return true;

          return contratistas.includes(idContratista);
        })
        // Filtro por supervisor
        .filter(({ responsables }) => {
          const responsablesaFiltrados = responsables.map(({ idFuncionario }) => idFuncionario);
          const { supervisores } = this.filtros;
          if (supervisores.length <= 0) return true;

          return supervisores.some((id) => responsablesaFiltrados.includes(id));
        })
        .filter((contrato) => {
          if (!this.filtros.buscarTexto) return contrato;
          const expt = new RegExp(this.filtros.buscarTexto, 'gi');
          const numero = this.$normalizacionTexto(contrato.numero);
          const meta = this.$normalizacionTexto(contrato.meta);
          const contratista = this.$normalizacionTexto(
            contrato.contratista.nombreRazonSocial,
          );
          return (
            expt.test(numero)
            || expt.test(meta)
            || expt.test(contratista)
            || expt.test(contrato.numero)
            || expt.test(contrato.meta)
            || expt.test(contrato.contratista.nombreRazonSocial)
          );
        });
    },
    getContratos() {
      // return this.seleccion === 'listadoActual'
      // ? this.getContratosExcelFiltrado : this.getContratosExcel;
      return this.getContratosExcel;
    },
    getHeaders() {
      const headers = this.headersColumnas
        .map((header) => header.value)
        .sort((a, b) => a.orden - b.orden);
      return headers;
    },
    getColumnas() {
      const columnas = this.headersColumnas
        .map((columna) => columna.nombreColumna)
        .sort((a, b) => a.orden - b.orden);
      return columnas;
    },
    crearDatosDocumento() {
      const inicial = this.$moment(this.rangoFechas.inicial).format('DD-MM-YYYY');
      const final = this.$moment(this.rangoFechas.final).format('DD-MM-YYYY');
      const datosDocumento = [];
      datosDocumento.push(
        {
          value: 'CONSULTA MAESTRA DE CONTRATOS',
          row: 1,
          col: 1,
          estilo: {
            font: {
              size: 14,
              bold: true,
            },
            alignment: {
              horizontal: 'center',
              vertical: 'center',
            },
          },
          combinar: {
            row: 1,
            col: 7,
          },
        },
      );
      if (this.seleccion === 'rangoFechas') {
        datosDocumento.push(
          {
            value: `${inicial} AL ${final}`,
            row: 2,
            col: 1,
            estilo: {
              font: {
                size: 14,
                bold: true,
              },
              alignment: {
                horizontal: 'center',
                vertical: 'center',
              },
            },
            combinar: {
              row: 2,
              col: 7,
            },
          },
        );
      }
      return datosDocumento;
    },
    getListaContratos() {
      const contratos = JSON.parse(JSON.stringify(this.getContratos));
      const listaContratosActual = [];
      const listaContratosRangoFecha = [];
      contratos.forEach((contrato) => {
        const obrasContrato = contrato.obras.sort((a, b) => b.importe - a.importe);

        const importeContrato = contrato.esObraFinanciada
          ? contrato.importeCostoDirecto
          + contrato.importeCostoIndirectos
          + contrato.importeUtilidad
          : contrato.importe;
        const datos = {
          ejercicio: contrato.ejercicio,
          numero: contrato.numero,
          fecha: this.$moment(contrato.fecha).format('DD-MM-YYYY'),
          meta: contrato.meta,
          programa: obrasContrato.length > 0 ? obrasContrato[0].obra.programa.nombre : '',
          tipo: obrasContrato.length > 0 ? obrasContrato[0].obra.tipo.descripcion : '',
          subtipo: obrasContrato.length > 0 ? obrasContrato[0].obra.subtipo.descripcion : '',
          comoSeContrato: contrato.comoSeContrato,
          contratista: contrato.contratista.nombreRazonSocial,
          esObraFinanciada: contrato.esObraFinanciada ? 'FINANCIADA' : 'NORMAL',
          fechaInicio: this.$moment(contrato.fechaInicio).format('DD-MM-YYYY'),
          fechaTermino: this.$moment(contrato.fechaTermino).format('DD-MM-YYYY'),
          modificadoFechaInicio: contrato.modificado.fechaInicio ? this.$moment(contrato.modificado.fechaInicio).format('DD-MM-YYYY') : '',
          modificadoFechaTermino: contrato.modificado.fechaTermino ? this.$moment(contrato.modificado.fechaTermino).format('DD-MM-YYYY') : '',
          importeCostoDirecto: {
            value: contrato.importeCostoDirecto,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeCostoIndirectos: {
            value: contrato.importeCostoIndirectos,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeUtilidad: {
            value: contrato.importeUtilidad,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeCargosAdicionales: {
            value: contrato.importeCargosAdicionales,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeAntesFinanciamiento: {
            // value: contrato.importeTotal,
            value: importeContrato + contrato.importeCargosAdicionales,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeCostoFinanciero: {
            value: contrato.importeCostoFinanciero,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeAntesIva: {
            value: contrato.importe,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeIva: {
            value: contrato.iva,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeTotal: {
            value: contrato.total,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeTotalDespuesDeConvenios: {
            value: contrato.total + contrato.modificado.total,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeAnticipoInicioTrabajos: {
            value: this.$ObjSumar(contrato.anticipos, 'importeInicioTrabajos'),
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeAnticipoFinanciamiento: {
            value: this.$ObjSumar(contrato.anticipos, 'importeCostoFinanciamiento'),
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeAnticipo: {
            value: this.$ObjSumar(contrato.anticipos, 'importe'),
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeIvaAnticipo: {
            value: this.$ObjSumar(contrato.anticipos, 'iva'),
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeTotalAnticipo: {
            value: this.$ObjSumar(contrato.anticipos, 'total'),
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          numeroEstimaciones: contrato.estimaciones.length,
          importeEstimadoCostoDirecto: {
            value: this.$ObjSumar(contrato.estimaciones, 'importeCostoDirecto'),
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeEstimadoIndirectos: {
            value: this.$ObjSumar(contrato.estimaciones, 'importeCostoIndirectos'),
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeEstimadoUtilidad: {
            value: this.$ObjSumar(contrato.estimaciones, 'importeUtilidad'),
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeEstimadoAdicionales: {
            value: this.$ObjSumar(contrato.estimaciones, 'importeCargosAdicionales'),
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeEstimado: {
            value: this.$ObjSumar(contrato.estimaciones, 'importeEstimado'),
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeEstimadoNormal: {
            value: this.$ObjSumar(this.getDatosExcedentesEstimaciones(contrato.estimaciones), 'importeEstimadoNormal'),
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeEstimadoExcedente: {
            value: this.$ObjSumar(this.getDatosExcedentesEstimaciones(contrato.estimaciones), 'importeEstimadoExcedente'),
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeEstimadoFueraPresupuesto: {
            value: this.$ObjSumar(this.getDatosExcedentesEstimaciones(contrato.estimaciones), 'ImporteEstimadoFueraPresupuesto'),
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importePorEstimar: {
            // value: contrato.total + contrato.modificado.total
            // - this.$ObjSumar(contrato.estimaciones, 'importeEstimado'),
            value: importeContrato + contrato.importeCargosAdicionales - this.$ObjSumar(contrato.estimaciones, 'importeEstimado'),
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeAmortizadoInicioTrabajos: {
            value: this.getAmortizacionesContrato(contrato.estimaciones)
              .importeAmortizadoInicioTrabajos,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeAmortizadoFinanciamiento: {
            value: this.getAmortizacionesContrato(contrato.estimaciones)
              .importeAmortizadoFinanciamiento,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeAmortizado: {
            value: this.getAmortizacionesContrato(contrato.estimaciones).importeAmortizado,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importePorAmortizar: {
            value: this.$ObjSumar(contrato.anticipos, 'importe') - this.getAmortizacionesContrato(contrato.estimaciones).importeAmortizado,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeEstimadoFinanciamiento: {
            value: this.$ObjSumar(contrato.estimaciones, 'importeCostoFinanciero'),
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeEstimacionesAntesIva: {
            value: contrato.esObraFinanciada ? this.$ObjSumar(contrato.estimaciones, 'subtotalDos') : this.$ObjSumar(contrato.estimaciones, 'subtotal'),
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeEstimacionesIva: {
            value: this.$ObjSumar(contrato.estimaciones, 'importeIva'),
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeEstimacionesFacturado: {
            value: this.$ObjSumar(contrato.estimaciones, 'totalFactura'),
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeEstimacionesDeducciones: {
            value: this.$ObjSumar(contrato.estimaciones, 'importeDeducciones'),
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeEstimacionesRetenido: {
            value: this.$ObjSumar(contrato.estimaciones, 'importeRetenido'),
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeEstimacionesDevuelto: {
            value: this.$ObjSumar(contrato.estimaciones, 'importeDevuelto'),
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeEstimacionesSancion: {
            value: this.$ObjSumar(contrato.estimaciones, 'importeSancion'),
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeEstimacionesAjuste: {
            value: this.$ObjSumar(contrato.estimaciones, 'importeBonificacion'),
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeEstimacionesLiquido: {
            value: this.$ObjSumar(contrato.estimaciones, 'importeLiquido'),
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeEscalatoriasAntesIva: {
            value: this.$ObjSumar(contrato.escalatorias, 'importe'),
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeEscalatoriasIva: {
            value: this.$ObjSumar(contrato.escalatorias, 'iva'),
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeEscalatoriasFacturado: {
            value: this.$ObjSumar(contrato.escalatorias, 'total'),
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeGastosAntesIva: {
            value: this.$ObjSumar(contrato.gastos, 'importe'),
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeGastosIva: {
            value: this.$ObjSumar(contrato.gastos, 'iva'),
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeGastosFacturado: {
            value: this.$ObjSumar(contrato.gastos, 'total'),
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeEjercidoContratoAntesIva: {
            value: this.getImportesEjercidosContrato(contrato).importeEjercidoContratoAntesIva,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeEjercidoContratoIva: {
            value: this.getImportesEjercidosContrato(contrato).importeEjercidoContratoIva,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeEjercidoContratoFacturado: {
            value: this.getImportesEjercidosContrato(contrato).importeEjercidoContratoFacturado,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeFacturdoSolicitado: {
            value: this.getSolicitadoPagado(contrato.solicitudesPagos).importeFacturadoSolicitado,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeFacturadoPagado: {
            value: this.getSolicitadoPagado(contrato.solicitudesPagos).importeFacturadoPagado,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          importeFacturadoPorPagar: {
            value: this.getImportesEjercidosContrato(contrato).importeEjercidoContratoFacturado
            - this.getSolicitadoPagado(contrato.solicitudesPagos).importeFacturadoPagado,
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          porcentajeAvanceProgramado: this.getDatosUltimoReporte(contrato.reportesFisicos)
            .avanceProgramado,
          porcentajeAvanceFisico: this.getDatosUltimoReporte(contrato.reportesFisicos)
            .avanceFisico,
          porcentajeAvanceFinanciero: this.getDatosUltimoReporte(contrato.reportesFisicos)
            .avanceFinanciero,
          atraso: this.getDatosUltimoReporte(contrato.reportesFisicos).atraso,
          residente: this.getResidenteContrato(contrato),
          fechaUltimoReporte: this.getDatosUltimoReporte(contrato.reportesFisicos)
            .fechaUltimoReporte,
          ultimoComentario: this.getDatosUltimoReporte(contrato.reportesFisicos).ultimoComentario,
          supervisionExterna: this.getSupervisionExterna(contrato),
          fechaUltimaEstimacion: this.getDatosEstimaciones(contrato.estimaciones)
            .fechaUltimaEstimacion,
          conEstimacionFiniquito: this.getDatosEstimaciones(contrato.estimaciones)
            .conEstimacionFiniquito,
          importeCatalogo: {
            value: this.$ObjSumar(contrato.catalogoConceptos, 'importe'),
            estilo: {
              numberFormat: '$#,##0.00',
            },
          },
          fechaInicioPrograma: this.getFechasPrograma(contrato.programas).fechaInicioPrograma,
          fechaFinPrograma: this.getFechasPrograma(contrato.programas).fechaTerminoPrograma,
          estatusContrato: contrato.estatus?.nombre,
          expedienteAbierto: {
            value: this.getDatosExpedienteContrato(contrato.expediente).abierto,
            estilo: {
              alignment: {
                horizontal: 'center',
                vertical: 'center',
              },
            },
          },
          documentosAplican: {
            value: this.getDatosExpedienteContrato(contrato.expediente).documentosAplican,
            estilo: {
              alignment: {
                horizontal: 'center',
                vertical: 'center',
              },
            },
          },
          documentosOk: {
            value: this.getDatosExpedienteContrato(contrato.expediente).documentosOk,
            estilo: {
              alignment: {
                horizontal: 'center',
                vertical: 'center',
              },
            },
          },
          documentosFaltantes: {
            value: this.getDatosExpedienteContrato(contrato.expediente)
              .documentosFaltantes,
            estilo: {
              alignment: {
                horizontal: 'center',
                vertical: 'center',
              },
            },
          },
        };
        listaContratosActual.push(datos);
        const isBetween = this.$moment(contrato.fecha)
          .isBetween(this.rangoFechas.inicial, this.rangoFechas.final, undefined, '[]');
        if (isBetween) {
          listaContratosRangoFecha.push(datos);
        }
      });
      return this.seleccion === 'rangoFechas' ? listaContratosRangoFecha : listaContratosActual;
    },
    crearExcelContratos() {
      // const expedientesExcel = this.getExpedientesParaExcel;
      const datosDocumento = this.crearDatosDocumento;
      const dataHeaders = this.getHeaders;
      const nombreDeColumnas = [...this.getColumnas];
      const bodyData = this.getListaContratos.length > 0 ? this.getListaContratos : this.noData;
      const data = {
        excelData: {
          configuration: this.configuracionExcel,
          header: {
            filaInicio: filaTitulos,
            estilo: this.estiloHeader,
            // logos: [...this.logoDocumento],
            datosDocumento: [...datosDocumento],
            data: [...dataHeaders],
          },
          body: {
            nombreDeColumnas,
            filaInicio: filaInicioDatos,
            data: bodyData,
          },
        },
      };
      return data;
    },
  },

};
</script>

<style>

</style>
